export default __webpack_public_path__ + "static/media/Archdeacon's Gauntlets of the Eighteen Pits.f1b4e118.jpg";